export default {
  model: [
    {
      label: 'Assunto',
      field: 'subject',
      type: 'text'
    },
    {
      label: 'Formule sua Questão',
      field: 'question',
      type: 'text'
    }
  ]
}